import { effect, signal } from "@preact/signals";
import { local } from "~/core/local";

const tmpStorage = local("_tmp_st_4", {
    sentInternal: [] as string[],
    approvedInternal: [] as string[],
    sentClient: [] as string[],
    approvedClient: [] as string[],
    board: [] as string[],
});

const makeMeta = () => {
    const title = signal("Marathon Engage");
    const prefix = signal("");

    // temporary solution
    const sentInternal = signal(tmpStorage.get().sentInternal);
    const approvedInternal = signal(tmpStorage.get().approvedInternal);
    const sentClient = signal(tmpStorage.get().sentClient);
    const approvedClient = signal(tmpStorage.get().approvedClient);
    const boardTasks = signal(tmpStorage.get().board);

    effect(() => {
        tmpStorage.set({
            sentInternal: sentInternal.value,
            approvedInternal: approvedInternal.value,
            sentClient: sentClient.value,
            approvedClient: approvedClient.value,
            board: boardTasks.value,
        });
    });

    return {
        title,
        prefix,
        sentInternal,
        sentClient,
        approvedInternal,
        approvedClient,
        boardTasks,
    };
};

export default makeMeta;
